export default __webpack_public_path__ + "static/media/raisa.5abe160d.png";